import type { TefComs4csMicroFrontend } from '@mfe-4cs/components/tef-coms4cs';
import { TemplateResult, html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import comsStore from '@mfe-4cs/state/ComsStore';

export function historyTemplate(this: TefComs4csMicroFrontend): TemplateResult {
  if (!comsStore.history || !comsStore.history.data) {
    return nothing as unknown as TemplateResult;
  }

  const { history } = comsStore;

  if (history.client.error) { // TODO: render error and spinner on history page
    return html`
      <one-text as="div">
        error loading history: ${history.client.error}
      </one-text>
    `;
  }

  return html`
  <one-stack>
    <one-text as="p"></one-text>
    <one-button-bar>
      <one-button
        variant="outline"
        @click=${() => { /* eslint-disable @typescript-eslint/indent */
        history.configId = undefined;
        } /* eslint-enable @typescript-eslint/indent */}
      >
      Zurück
      </one-button>
    </one-button-bar>

    <one-panel variant="muted">
      <one-stack>
        <one-heading level="h6">
        ${unsafeHTML(history.consentShortScope)}
        </one-heading>
        <tef-coms-pagination></tef-coms-pagination>
      </one-stack>
    </one-panel>
  </one-stack>
  `;
}
